var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.taskCardContentClasses},[_c('span',{staticClass:"TaskCardContent__text"},[_vm._v(" "+_vm._s(_vm.description)+" ")]),_c('TaskStatus',{attrs:{"task":_vm.taskComputed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }